import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { CheckCircle, Lightning } from "@phosphor-icons/react";

export default function MachineDialog({ machine, onClose, onEnquire }) {
  const hasFeatures = machine && machine.features && machine.features.length > 0;
  const hasSpecs = machine && machine.specs && machine.specs.length > 0;
  return (
    <Dialog open={!!machine} onOpenChange={(open) => !open && onClose()}>
      <DialogContent data-testid="machine-dialog" className="max-h-[90vh] max-w-3xl overflow-y-auto rounded-none border-border bg-white p-0">
        {machine && (
          <div>
            <div className="relative flex h-64 items-center justify-center bg-[#EDEFF2] sm:h-80">
              <img src={machine.image} alt={machine.name} className="h-full w-full object-cover object-[center_35%]" />
              {machine.power && machine.power !== "-" && (
                <span className="absolute bottom-4 left-6 flex items-center gap-2 bg-laser px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-white">
                  <Lightning size={14} weight="bold" /> {machine.power}
                </span>
              )}
            </div>
            <div className="p-6 sm:p-8">
              <DialogHeader>
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-laser">{machine.category}</p>
                <DialogTitle data-testid="machine-dialog-title" className="mt-1 text-left text-2xl font-bold text-[#222] sm:text-3xl">
                  {machine.name}
                </DialogTitle>
              </DialogHeader>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{machine.description}</p>
              {(hasFeatures || hasSpecs) && (
                <div className={`mt-8 grid grid-cols-1 gap-8 ${hasFeatures && hasSpecs ? "sm:grid-cols-2" : ""}`}>
                  {hasFeatures && (
                    <div>
                      <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-navy">Characteristics</h4>
                      <ul className="mt-4 space-y-3">
                        {machine.features.map((f, i) => (
                          <li key={i} className="flex items-start gap-2.5 text-sm text-[#444]" data-testid={`machine-feature-${i}`}>
                            <CheckCircle size={18} weight="duotone" className="mt-0.5 shrink-0 text-laser" /> {f}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {hasSpecs && (
                    <div>
                      <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-navy">Technical Parameters</h4>
                      <Table className="mt-4" data-testid="machine-spec-table">
                        <TableBody>
                          {machine.specs.map((s, i) => (
                            <TableRow key={i} className={i % 2 === 0 ? "border-border bg-white" : "border-border bg-[#F4F5F7]"}>
                              <TableCell className="py-2.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{s.k}</TableCell>
                              <TableCell className="py-2.5 text-right text-sm text-[#222]">{s.v}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  )}
                </div>
              )}
              <button
                data-testid="machine-enquire-btn"
                onClick={() => onEnquire(machine)}
                className="mt-8 w-full bg-laser px-7 py-4 text-sm font-semibold uppercase tracking-[0.15em] text-white transition-colors duration-150 hover:bg-laser-hover"
              >
                Enquire about the {machine.name}
              </button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
